export const inUnits = (num: number, unit: string, suffix = 's') =>
  `${num} ${unit}${Number(num) === 1 ? '' : suffix}`;

export const isEmpty = (val: any) => {
  if (Array.isArray(val) || typeof val === 'string') {
    return val.length === 0;
  } else if (typeof val === 'object') {
    return Object.values(val).length === 0;
  }
  return false;
};

export const isFunction = (maybeFn: any) => typeof maybeFn === 'function';

export const isNil = (val: any) => val === null || val === undefined;

export const isObject = (obj: any) => typeof obj === 'object' && obj !== null;

export const deepEqual = (
  obj1: Record<string, any>,
  obj2: Record<string, any>,
) => {
  if (obj1 === obj2) {
    return true;
  } else if (isObject(obj1) && isObject(obj2)) {
    if (Object.keys(obj1).length !== Object.keys(obj2).length) {
      return false;
    }
    for (const prop in obj1) {
      if (!deepEqual(obj1[prop], obj2[prop])) {
        return false;
      }
    }
    return true;
  }
  return false;
};

export const maybeCall = (fn: any, ...args: any[]) =>
  isFunction(fn) ? fn(...args) : fn;

// eslint-disable-next-line @typescript-eslint/no-empty-function
export const noop = () => {};

export const uniq = <T>(list: T[]): T[] =>
  list.filter((v, i, l) => l.indexOf(v) === i);

export const uniqBy = <T>(transform: (t: T) => any, list: T[]): T[] =>
  list.reduce((acc, val) => {
    return acc.find((i) => transform(i) === transform(val))
      ? acc
      : [...acc, val];
  }, [] as T[]);
